import React, { useEffect, useState } from "react";
import Error from "../components/error";

const AuthError = () => {
    const [error, setError] = useState(null);
    const [errorDescription, setErrorDescription] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        let errorVal = params.get("error");
        const errorDes = params.get("error_description");
        if (errorVal) {
            errorVal = errorVal.toUpperCase().replace(/_/g, " ");
            setError(errorVal);
        }
        if (errorDes) {
            setErrorDescription(errorDes);
        }
    }, []);

    return (
        <div>
            <Error error={error} errorDescription={errorDescription} />
        </div>
    );
};

export default AuthError;
